/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Attendance_State_YesInputs */

const en_interview_attendance_state_yes = /** @type {(inputs: Interview_Attendance_State_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marked as attended`)
};

const de_interview_attendance_state_yes = /** @type {(inputs: Interview_Attendance_State_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als stattgefunden markiert`)
};

/**
* | output |
* | --- |
* | "Marked as attended" |
*
* @param {Interview_Attendance_State_YesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_attendance_state_yes = /** @type {((inputs?: Interview_Attendance_State_YesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Attendance_State_YesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_attendance_state_yes(inputs)
	return en_interview_attendance_state_yes(inputs)
});